module.exports = __webpack_public_path__ + "assets/img/about.bdec9479.png";